module.exports = __webpack_public_path__ + "pc/img/rec_01.f7202941.svg";